export const filterList = [
  {
    id: 1,
    name: "Email",
    value: "email",
  },
  {
    id: 2,
    name: "Screen Name",
    value: "screen_name",
  },
];
